export class AppMenuItem {
    code: string;
    id: string;
    icon: string;
    name: string;
}
